module.exports = __webpack_public_path__ + "img/olej1.b6f8a392.jpg";